import React, { useMemo, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import DateFild from '../../components/DateTimePicker/DateFild';
import { FaFilePdf, FaEye } from "react-icons/fa";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    ClassicEditor,
    Essentials,
    Paragraph,
    Heading,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Code,
    Subscript,
    Superscript,
    Font,
    FontFamily,
    FontSize,
    FontColor,
    FontBackgroundColor,
    Alignment,
    Link,
    List,
    TodoList,
    BlockQuote,
    Indent,
    IndentBlock,
    Table,
    TableToolbar,
    TableProperties,
    TableCellProperties,
    HorizontalLine,
    RemoveFormat,
    SpecialCharacters,
    SourceEditing,
    GeneralHtmlSupport,
    Undo
} from 'ckeditor5';
import { postInvoice, postInvoiceDetails, postCommonMaster, postPaymentSave, postInvoiceMailMaster, postEmailTemplateRenderBody, postDocumentFileList, postInvoiceSend } from '../../apiservices/ApiServices';

const Invoices = () => {
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [payModal, setPayModal] = useState(false);
    const [sendMailModal, setSendMailModal] = useState(false);
    const [data, setData] = useState([]);
    const [invoiceData, setInvoiceData] = useState([]);
    const [invoicesNo, setInvoicesNo] = useState('');
    const [commonMaster, setCommonMaster] = useState([]);
    const [selectedInv, setSelectedInv] = useState([]);

    const [invoicesInfo, setInvoicesInfo] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [ccselectedIds, setccSelectedIds] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState([]);
    const [documentListData, setDocumentListData] = useState([]);

    const [emailBody, setEmailBody] = useState('');

    const postInvoices = async (postData) => {
        setLoading(true);
        try {
            const res = await postInvoice(postData);
            setData(res?.data?.data?.records);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdates = async () => {
        let postData = {
            length: 100
        }
        setLoadings(true);
        try {
            const res = await postInvoice(postData);
            setData(res?.data?.data?.records);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postInvoices(postData);
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: "Invoice Number",
                accessor: "invoice_no",
            },
            {
                Header: "Invoice Date",
                accessor: "invoice_date",
            },
            {
                Header: "Billing Entity Name",
                accessor: "billing_entity_name",
            },
            {
                Header: "Client Name",
                accessor: "client_name",
            },
            {
                Header: "Project Name",
                accessor: "project_category",
            },
            {
                Header: "Due Date",
                accessor: "due_date",
            },
            {
                Header: "Over Due Days",
                accessor: "over_due_days",
            },
            {
                Header: "Invoice Amount",
                accessor: "invoice_amount",
            },
            {
                Header: "Paid Amount",
                accessor: "paid_amount",
            },
            {
                Header: "Pending Amount",
                accessor: "pending_amount",
            },
            {
                Header: "Status",
                accessor: "status",
            },

            {
                Header: "Action",
                accessor: "action",
                billingAmount: true,
            },
        ],
        []
    );

    const actions = ['sendEmails', 'Invoice Download', 'pay']

    const initialValues = {
        paymentAmount: '',
        paymentMode: '',
        paymentDate: '',
        bankName: '',
        paymentReceivedDate: '',
        narration: '',
        paymentType: '',
        referenceNo: '',

        invoiceId: '',
        beId: '',
        activityoutputTemplateId: '',
        fromContactList: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);

            if (payModal) {
                let postData = {
                    payment_amount: values.paymentAmount,
                    payment_mode_id: values.paymentMode,
                    payment_date: values.paymentDate,
                    reference_no: values.referenceNo,
                    bank_name: values.bankName,
                    payment_received_date: values.paymentReceivedDate,
                    narration: values.narration,
                    invoices: selectedInv?.map((item) => ({
                        invoice_id: item?.invoice_id,
                        amount: item?.amount,
                    })),
                }
                try {
                    const res = await postPaymentSave(postData);
                    toast.success(res.data.message);
                    setLoadings(false);
                    postUpdates();
                    setPayModal(false);
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (sendMailModal) {
                let postData = {
                    invoice_id: values.invoiceId,
                    from_user_id: values.fromContactList,
                    to_user_ids: selectedIds,
                    cc_user_ids: ccselectedIds,
                    email_subject: values.subject,
                    email_body: emailBody,
                    document_file_ids: selectedDocument,
                }

                try {
                    const res = await postInvoiceSend(postData);
                    toast.success(res.data.message);
                    setSendMailModal(false);
                    setLoadings(false);
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const postRenderEmailBody = async (postData) => {
        setLoadings(true);
        setEmailBody('');
        setFieldValue('subject', '');
        try {
            const res = await postEmailTemplateRenderBody(postData);
            setEmailBody(res.data.data?.body || '');
            setFieldValue('subject', res.data.data?.subject);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
        }
    };

    const handlePay = async (rowData) => {
        formik.resetForm();
        setLoadings(true);
        try {
            let postData = {
                type: [
                    "project_category",
                    "payment_mode",
                    "client_source",
                ],
                org_type_code: ''
            }
            const commonData = await postCommonMaster(postData);
            setCommonMaster(commonData.data.data);

            let postDatas = {
                invoice_id: rowData?.invoice_id
            }
            try {
                const res = await postInvoiceDetails(postDatas);
                setInvoiceData(res?.data?.data);
                setPayModal(true);
                setLoadings(false);
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }

    };

    const handleSendEmail = async (rowData) => {
        formik.resetForm();

        setInvoicesInfo([]);
        setSelectedIds([]);
        setccSelectedIds([]);
        setSelectedDocument([]);
        setDocumentListData([]);
        setEmailBody('');

        setLoadings(true);

        let postData = {
            invoice_id: rowData?.invoice_id
        }
        try {
            const res = await postInvoiceMailMaster(postData);
            setFieldValue('invoiceId', rowData?.invoice_id);
            setInvoicesInfo(res?.data?.data);

            let postDatas = {
                billing_entity_id: res?.data?.data?.billing_entity?.billing_entity_id,
                email_template_id: values?.activityoutputTemplateId
            }
            postDocumentFileLists(postDatas);


            setSendMailModal(true);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleConfirm = () => {
        formik.resetForm();
        setPayModal(false);
        setSendMailModal(false);
    };

    const handleViewInvoices = async (rowData) => {
        try {
            const response = await fetch(rowData.invoice_file);
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "invoice.pdf";
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    useEffect(() => {
        if (values.payAmount) {
            let tot = values.dueAmount - values.payAmount;
            setFieldValue('pendingAmount', tot);
        } else {
            setFieldValue('pendingAmount', values.dueAmount);
        }
    }, [values.payAmount, values.dueAmount, setFieldValue]);

    const postDocumentFileLists = async (postData) => {
        setLoadings(false);
        try {
            const res = await postDocumentFileList(postData);
            setDocumentListData(res.data.data);
            setLoadings(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
            setLoadings(false);
        }
    };

    useEffect(() => {
        if (sendMailModal) {
            setLoadings(false);
            let postData = {
                billing_entity_id: invoicesInfo?.billing_entity?.billing_entity_id,
                email_template_id: values?.activityoutputTemplateId
            }
            postDocumentFileLists(postData);

        }
    }, [values?.activityoutputTemplateId]);

    useEffect(() => {
        if (sendMailModal) {
            let postData = {
                invoice_id: values.invoiceId,
                email_template_id: values?.activityoutputTemplateId,
                from_person_id: values?.fromContactList,
                document_file_ids: selectedDocument
            }
            postRenderEmailBody(postData);
        }
    }, [values?.activityoutputTemplateId, values?.fromContactList, selectedDocument]);

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Invoices" active="Invoices" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table notAddnew">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Invoices</h1>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        onPay={handlePay}
                                        onPdfDownload={handleViewInvoices}
                                        onSendEmails={handleSendEmail}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={payModal}
                handleClose={() => setPayModal(false)}
                title={'Payment Info'}
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className='fieldsets'>
                        <div className='fieldsets-title'>Payment Info</div>
                        <table className="table table-bordered text-nowrap mb-0">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Invoice No</th>
                                    <th>Invoice Date</th>
                                    <th>Project Category</th>
                                    <th>Due Date</th>
                                    <th>Invoice Amount</th>
                                    <th>Paid Amount</th>
                                    <th>Pending Amount</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoiceData?.map((item) => (
                                    <tr key={`tab_invoice_${item?.invoice_id}`}>
                                        <td className='rdotd'>
                                            <input
                                                type="checkbox"
                                                value={item.invoice_id}
                                                checked={selectedInv.some(inv => inv.invoice_id === item.invoice_id)}
                                                onChange={(e) => {
                                                    setSelectedInv(prev =>
                                                        e.target.checked
                                                            ? [...prev, { ...item, amount: '' }]
                                                            : prev.filter(inv => inv.invoice_id !== item.invoice_id)
                                                    );
                                                }}

                                            />
                                        </td>
                                        <td>{item?.invoice_no}</td>
                                        <td>{item?.invoice_date}</td>
                                        <td>{item?.project_category}</td>
                                        <td>{item?.due_date}</td>
                                        <td>{item?.invoice_amount}</td>
                                        <td>{item?.paid_amount}</td>
                                        <td>{item?.pending_amount}</td>
                                        <td>{item?.status}</td>
                                        <td><a href={item?.invoice_file} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <Row>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Payment Amount</label>
                                <input
                                    type='text'
                                    id="paymentAmount"
                                    name="paymentAmount"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.paymentAmount}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.paymentAmount && touched.paymentAmount && (
                                    <p className="errormsg">{errors.paymentAmount}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Select Payment Mode</label>
                                <SelectFild
                                    Firstop='Select Payment Mode'
                                    selectName="paymentMode"
                                    options={commonMaster?.payment_mode}
                                    value={values.paymentMode}
                                    onChange={(selectedOption) => setFieldValue("paymentMode", selectedOption?.value || "")}
                                    onBlur={handleBlur}
                                />
                                {errors.paymentMode && touched.paymentMode && (
                                    <p className="errormsg">{errors.paymentMode}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Payment Date</label>
                                <DateFild
                                    value={values.paymentDate}
                                    onChange={(date) => setFieldValue('paymentDate', date)}
                                />
                                {errors.paymentDate && touched.paymentDate && (
                                    <p className="errormsg">{errors.paymentDate}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='fieldsets'>
                                <div className='fieldsets-title'>Invoice Amount</div>
                                <div className="form-group">
                                    <div className="table-responsive">
                                        <table className="table table-bordered text-nowrap mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Invoice No</th>
                                                    <th>Invoice Amount</th>
                                                    <th>Pending Amount</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedInv?.map((item) => (
                                                    <tr key={item.invoice_id}>
                                                        <td>{item.invoice_no}</td>
                                                        <td>{item.invoice_amount}</td>
                                                        <td>{item.pending_amount}</td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                value={item.amount || ''}
                                                                onChange={(e) => {
                                                                    setSelectedInv(prev =>
                                                                        prev.map(inv =>
                                                                            inv.invoice_id === item.invoice_id
                                                                                ? { ...inv, amount: e.target.value }
                                                                                : inv
                                                                        )
                                                                    );
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Bank Name</label>
                                <input
                                    type='text'
                                    id="bankName"
                                    name="bankName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.bankName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.bankName && touched.bankName && (
                                    <p className="errormsg">{errors.bankName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Reference No</label>
                                <input
                                    type='text'
                                    id="referenceNo"
                                    name="referenceNo"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.referenceNo}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.referenceNo && touched.referenceNo && (
                                    <p className="errormsg">{errors.referenceNo}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Payment Received Date</label>
                                <DateFild
                                    value={values.paymentReceivedDate}
                                    onChange={(date) => setFieldValue('paymentReceivedDate', date)}
                                />
                                {errors.paymentReceivedDate && touched.paymentReceivedDate && (
                                    <p className="errormsg">{errors.paymentReceivedDate}</p>
                                )}
                            </div>
                        </Col>

                        <Col md={4}>
                            <div className="form-group">
                                <label className="form-label">Narration</label>
                                <textarea
                                    id="narration"
                                    name="narration"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.narration}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.narration && touched.narration && (
                                    <p className="errormsg">{errors.narration}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={sendMailModal}
                handleClose={() => setSendMailModal(false)}
                title="Send Mail"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">From</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicesInfo?.billing_entity_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="fromContactList"
                                                            value={item?.user_id}
                                                            checked={values.fromContactList == item?.user_id}
                                                            onChange={(e) => { setFieldValue('fromContactList', e.target.checked ? item?.user_id : ''); }}
                                                            onBlur={handleBlur}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">To</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicesInfo?.client_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="checkbox"
                                                            value={item.user_id}
                                                            checked={selectedIds.includes(item.user_id)}
                                                            onChange={(e) => {
                                                                const id = item.user_id;
                                                                setSelectedIds(prev =>
                                                                    e.target.checked
                                                                        ? [...prev, id]
                                                                        : prev.filter(pid => pid !== id)
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">CC</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicesInfo?.billing_entity_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="checkbox"
                                                            value={item.user_id}
                                                            checked={ccselectedIds.includes(item.user_id)}
                                                            onChange={(e) => {
                                                                const id = item.user_id;
                                                                setccSelectedIds(prev =>
                                                                    e.target.checked
                                                                        ? [...prev, id]
                                                                        : prev.filter(pid => pid !== id)
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Select Email Template</label>
                                <SelectFild
                                    Firstop='Select Email Template'
                                    selectName="activityoutputTemplateId"
                                    options={invoicesInfo?.email_template}
                                    value={values.activityoutputTemplateId}
                                    onChange={(selectedOption) => {
                                        setFieldValue('activityoutputTemplateId', selectedOption?.value || "");
                                    }}
                                    onBlur={handleBlur}
                                />
                                {errors.activityoutputTemplateId && touched.activityoutputTemplateId && (
                                    <p className="errormsg">{errors.activityoutputTemplateId}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Subject</label>
                                <input
                                    type='text'
                                    id="subject"
                                    name="subject"
                                    className="form-control"
                                    value={values.subject}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.subject && touched.subject && (
                                    <p className="errormsg">{errors.subject}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Email Body</label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={emailBody}
                                    config={{
                                        licenseKey: 'GPL',
                                        plugins: [
                                            Essentials,
                                            Paragraph,
                                            Heading,
                                            Bold,
                                            Italic,
                                            Underline,
                                            Strikethrough,
                                            Code,
                                            Subscript,
                                            Superscript,
                                            Font,
                                            FontFamily,
                                            FontSize,
                                            FontColor,
                                            FontBackgroundColor,
                                            Alignment,
                                            Link,
                                            List,
                                            TodoList,
                                            BlockQuote,
                                            Indent,
                                            IndentBlock,
                                            Table,
                                            TableToolbar,
                                            TableProperties,
                                            TableCellProperties,
                                            HorizontalLine,
                                            RemoveFormat,
                                            SpecialCharacters,
                                            SourceEditing,
                                            GeneralHtmlSupport
                                        ],

                                        toolbar: [
                                            'undo', 'redo',
                                            '|',
                                            'heading',
                                            '|',
                                            'fontFamily',
                                            'fontSize',
                                            'fontColor',
                                            'fontBackgroundColor',
                                            '|',
                                            'bold',
                                            'italic',
                                            'underline',
                                            'strikethrough',
                                            '|',
                                            'alignment',
                                            '|',
                                            'bulletedList',
                                            'numberedList',
                                            'todoList',
                                            '|',
                                            'outdent',
                                            'indent',
                                            '|',
                                            'link',
                                            'insertTable',
                                            '|',
                                            'blockQuote',
                                            'horizontalLine',
                                            'removeFormat',
                                            '|',
                                            'sourceEditing'
                                        ],

                                        table: {
                                            contentToolbar: [
                                                'tableColumn',
                                                'tableRow',
                                                'mergeTableCells',
                                                'tableProperties',
                                                'tableCellProperties'
                                            ]
                                        },

                                        htmlSupport: {
                                            allow: [
                                                {
                                                    name: /.*/,
                                                    attributes: true,
                                                    classes: true,
                                                    styles: true
                                                }
                                            ]
                                        }
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        setEmailBody(data);
                                    }}
                                    onReady={(editor) => {
                                        console.log('Editor is ready to use!', editor);
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log('Blur.', editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log('Focus.', editor);
                                    }}
                                />
                            </div>
                        </Col>
                        {documentListData?.common_document?.length > 0 && (
                            <Col md={12}>
                                <div className='fieldsets'>
                                    <div className='fieldsets-title'>Common Document</div>
                                    <div className='attachmentsList'>
                                        <ul>
                                            {documentListData?.common_document?.map((item) => (
                                                <li>
                                                    <div className='listcards'>
                                                        <h4>{item?.document_title}</h4>
                                                        <ul>
                                                            {item?.files?.map((files) => (
                                                                <li>
                                                                    <div className='attBox'>
                                                                        <div className="chkBox">
                                                                            <input
                                                                                type="checkbox"
                                                                                value={files.document_file_id}
                                                                                checked={selectedDocument.includes(files.document_file_id)}
                                                                                onChange={(e) => {
                                                                                    const id = files.document_file_id;
                                                                                    setSelectedDocument(prev =>
                                                                                        e.target.checked
                                                                                            ? [...prev, id]
                                                                                            : prev.filter(pid => pid !== id)
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="pdf-icon">
                                                                            <FaFilePdf size={16} color="#e74c3c" />
                                                                        </div>
                                                                        <p>{files?.file_name}</p>
                                                                        <a href={files?.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                    <div className="previewsimges" style={{ paddingTop: 0 }}>
                        <div className='imageboxs'>
                            <div className='imgs pdfs'>
                                <div>
                                    <div className="pdf-icon">
                                        <FaFilePdf size={48} color="#e74c3c" />
                                    </div>
                                    <p>{invoicesInfo?.invoice?.invoice_no}.pdf</p>
                                    <a href={invoicesInfo?.invoice?.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Send</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>
        </>
    )

}

export default Invoices